webpackJsonp([113908314691932],{

/***/ 1681:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CardconnectVerifyCredentialsResult","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"reason","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"valid","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"Boolean","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-cardconnect-verify-credentials-result-4770ea587cb84a5d26bf.js